import React from 'react';
import SbEditable from 'storyblok-react';
import styled from 'styled-components';

const MapLegendItem = (props) => {
  return (
    <SbEditable content={props.blok}>
      <MapLegendItemContainer>
        <MapDot color={props.blok.color.color} />
        <Title>{props.blok.title}</Title>
      </MapLegendItemContainer>
    </SbEditable>
  );
};

const MapLegendItemContainer = styled.div`
  display: flex;
  align-items: center;
`;

const MapDot = styled.span`
  width: 17px;
  height: 17px;
  display: inline-block;
  border-radius: 50%;
  background-color: ${(props) => props.color};
`;

const Title = styled.span`
  display: inline-block;
  margin-left: 9px;
  font-size: 0.8rem;
  font-weight: 600;
`;

export default MapLegendItem;
